import React from 'react';
import { connect } from 'react-redux';
import { getAllRequests } from '../../../redux/actions/requests';
import ControlsComponent from '../../../components/RequestCard/Controls/Controls';

class Controls extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }
  getVal() {
    const { requests, id } = this.props;
    let result = { prev: null, next: null },
      currentIndex;
    if (requests && requests.length > 1) {
      currentIndex = requests.findIndex(item => item.id === id);
      result.prev = currentIndex - 1 >= 0 ? requests[currentIndex - 1] : null;
      result.next =
        currentIndex + 1 <= requests.length ? requests[currentIndex + 1] : null;
    }
    return result;
  }

  componentDidMount() {
    const { requests } = this.props;
    if (!requests) {
      this.props.getAllRequests();
    }
  }

  render() {
    const val = this.getVal();
    return <ControlsComponent prev={val.prev} next={val.next} />;
  }
}

export default connect(
  state => ({
    requests: state.Executorship.Requests.requests.allRequests,
    isLoading: state.Executorship.Requests.requests.requestsLoading,
  }),
  {
    getAllRequests,
  }
)(Controls);
